import React, { useState } from 'react';

const Input = ({ 
  label, 
  name, 
  type = 'text', 
  value, 
  onChange, 
  error, 
  disabled = false, 
  required = false,
  placeholder,
  icon, // New prop for custom icon
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mt-4 mb-4 text-left">
      {label && (
        <label className="text-[14px] sm:text-[16px] md:text-[18px] font-semibold text-[#38485C]" htmlFor={name}>
          {label}{required && ' *'}
        </label>
      )}
      <div className="relative">
        <input
          type={isPassword ? (showPassword ? 'text' : 'password') : type}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className={`w-full px-4 py-3 placeholder:text-[14px] sm:placeholder:text-[16px] placeholder:font-semibold placeholder:text-[#AFB0B2] border rounded-lg mt-1 focus:outline-none focus:ring-2 text-[14px] sm:text-[16px] font-semibold text-[#38485C] ${
            error ? 'border-[#EF466F] focus:ring-[#EF466F]' : 'border-[#E3E3E3] focus:ring-[#027BC6] focus:border-[#027BC6]'
          } ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}`}
          style={{ height: '56px', minHeight: '56px' }}
          {...props}
        />
        {/* Password visibility toggle */}
        {isPassword && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm"
          >
            <svg 
              className="w-5 h-5" 
              fill="none" 
              stroke="#9A9A9A" 
              viewBox="0 0 24 24"
            >
              {showPassword ? (
                <>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
                </>
              ) : (
                <>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </>
              )}
            </svg>
          </button>
        )}
        
        {/* Custom icon support */}
        {icon && !isPassword && (
          <div className="absolute right-3 top-5 text-gray-500 text-sm">
            <img 
              src={icon} 
              alt="Input icon" 
              className="w-5 h-5"
            />
          </div>
        )}
      </div>
      {error && (
        <div className="flex items-center mt-2">
          <svg 
            className="w-4 h-4 text-[#EF466F] mr-2 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <p className="text-[#EF466F] text-xs sm:text-sm">{error}</p>
        </div>
      )}
    </div>
  );
};

export default Input;